import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { Department } from '@dro/app/core/stores/departments/department.type';
import { SKIP_AUTH } from '@dro/app/core/http/http-context-tokens';

@Injectable({ providedIn: 'root' })
export class DepartmentsService {
  private readonly http = inject(HttpClient);

  load(): Observable<Array<Department>> {
    return this.http.get<Array<Department>>(`api/v1/tickets/departments`, {
      context: new HttpContext().set(SKIP_AUTH, true),
    });
  }
}
